import React from 'react';
import DataColumns from '@hud/web-components/DataColumns/DataColumns';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';
import { formatDateTime } from '@hud/web-components/utils';
import { SingleEntityLink } from '../../../components/EntitiesPopover/EntitiesPopover';
import { Container } from '@hud/web-components/Container/Container';
import {
  Endpoint as EndpointData,
  EntryFunction,
} from '@hud/portal-dtos/webapp-endpoint.dto';
import { LinkCell } from '@hud/web-components/Table/Table';
import { useFiltersForFunction } from '../../../hooks/useFiltersForFunction';

export interface EndpointOverviewProps {
  endpoint?: EndpointData;
  entryFunction?: EntryFunction | null;
  loading: boolean;
  globalUrlParams: string;
  tags?: Record<string, string>;
}

export default function EndpointOverview({
  endpoint,
  loading,
  entryFunction,
  tags,
}: EndpointOverviewProps) {
  const filtersForFunction = useFiltersForFunction(
    endpoint?.id,
    endpoint?.service.id ? [{ id: endpoint?.service.id }] : [],
    tags,
  );
  return (
    <Container
      variant="filled"
      title="Details"
      icon="webviewMenu.info"
      width="100%"
    >
      <DataColumns.WrappableColumns>
        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="Path">
            <LongContentPopover reverseEllipsis>
              {endpoint?.path}
            </LongContentPopover>
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Service">
            <SingleEntityLink to={`/explore/services/${endpoint?.service.id}`}>
              {endpoint?.service.name}
            </SingleEntityLink>
          </DataColumns.Row>
        </DataColumns.Column>
        <DataColumns.Column>
          <DataColumns.Row loading={loading} title="Last tracked invocation">
            {endpoint?.lastSeenAt
              ? formatDateTime(endpoint.lastSeenAt, true)
              : '-'}
          </DataColumns.Row>
          <DataColumns.Row loading={loading} title="Entry function">
            {entryFunction ? (
              <LinkCell
                to={`/explore/functions/${entryFunction.id}?${filtersForFunction}`}
              >
                <LongContentPopover>{entryFunction.name}</LongContentPopover>
              </LinkCell>
            ) : (
              'N/A'
            )}
          </DataColumns.Row>
        </DataColumns.Column>
      </DataColumns.WrappableColumns>
    </Container>
  );
}
